export default __webpack_public_path__ + "e2fd673c7fbf940c9d37dab3d6969dc5.mp3";